export const pagination = (state) => (state.pagination);
export const successfulBidders = (state) => Object.values(state.list || {});
export const selectedBidder = (state) => (state.selectedBidder);
export const loading = (state) => (state.loading);
